import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor() { }

  private readonly filtersPanelSubscriptionMessageSource = new BehaviorSubject(null);
  showFiltersPanelSubscription = this.filtersPanelSubscriptionMessageSource.asObservable();

  private readonly runQueryMessageSource = new BehaviorSubject(null);
  runQuery = this.runQueryMessageSource.asObservable();

  private readonly closeAllPanelsMessageSource = new BehaviorSubject(null);
  closeAllPanels = this.closeAllPanelsMessageSource.asObservable();

  private readonly resetQueryMessageSource = new BehaviorSubject(null);
  resetQuery = this.resetQueryMessageSource.asObservable();

  private readonly setToolbarButtonsEnabledMessageSource = new BehaviorSubject(null);
  toolbarButtonsEnabled = this.setToolbarButtonsEnabledMessageSource.asObservable();

  // private readonly setGlobalErrorsMessageSource = new BehaviorSubject(null);
  // globalErrors = this.setGlobalErrorsMessageSource.asObservable();

  private readonly refreshQueryHistoryMessageSource = new BehaviorSubject(null);
  refreshQueryHistory = this.refreshQueryHistoryMessageSource.asObservable();

  private readonly refreshSavedQueriesMessageSource = new BehaviorSubject(null);
  refreshSavedQueries = this.refreshSavedQueriesMessageSource.asObservable();

  private readonly currentCommonInputSelectionsMessageSource = new BehaviorSubject(null);
  currentCommonInputSelections = this.currentCommonInputSelectionsMessageSource.asObservable();

  private readonly activeSavedFiltersMessageSource = new BehaviorSubject(null);
  activeSavedFilters = this.activeSavedFiltersMessageSource.asObservable();

  private readonly activeQueryNameMessageSource = new BehaviorSubject(null);
  activeQueryName = this.activeQueryNameMessageSource.asObservable();

  private readonly activeQueryIdMessageSource = new BehaviorSubject(null);
  activeQueryId = this.activeQueryIdMessageSource.asObservable();

  private readonly rawResultsMessageSource = new BehaviorSubject(null);
  rawResultsData = this.rawResultsMessageSource.asObservable();

  private readonly lastExecutedQueryInfoMessageSource = new ReplaySubject(1);
  lastExecutedQueryInfo = this.lastExecutedQueryInfoMessageSource.asObservable();

  private readonly allIndicationsMessageSource = new BehaviorSubject(null);
  allIndications = this.allIndicationsMessageSource.asObservable();

  private readonly indicationSelectionsMessageSource = new BehaviorSubject(null);
  indicationSelections = this.indicationSelectionsMessageSource.asObservable();

  private readonly selectedDataSetsMessageSource = new BehaviorSubject(null);
  selectedDataSets = this.selectedDataSetsMessageSource.asObservable();

  private readonly selectedSearchIndicationMessageSource = new BehaviorSubject(null);
  selectedSearchIndication = this.selectedSearchIndicationMessageSource.asObservable();

  private readonly setValidationErrorsMessageSource = new BehaviorSubject(null);
  validationErrors = this.setValidationErrorsMessageSource.asObservable();

  private readonly forceRunValidationCheckMessageSource = new BehaviorSubject(null);
  forceRunValidationCheck = this.forceRunValidationCheckMessageSource.asObservable();

  private readonly summarySectionInfoMessageSource = new BehaviorSubject(null);
  summarySectionInfo = this.summarySectionInfoMessageSource.asObservable();

  setFiltersPanelSubscription(show: boolean) {
    this.filtersPanelSubscriptionMessageSource.next(show);
  }

  setRunQuery() {
    this.runQueryMessageSource.next(true);
  }

  setcloseAllPanels() {
    this.closeAllPanelsMessageSource.next(true);
  }

  setResetQuery() {
    this.resetQueryMessageSource.next(true);
  }

  setToolbarButtonsEnabled(data: boolean) {
    this.setToolbarButtonsEnabledMessageSource.next(data);
  }

  // setGlobalErrors(data: object) {
  //   this.setGlobalErrorsMessageSource.next(data);
  // }

  setRefreshQueryHistory() {
    this.refreshQueryHistoryMessageSource.next(true);
  }

  setRefreshSavedQueries() {
    this.refreshSavedQueriesMessageSource.next(true);
  }

  setCurrentCommonInputSelections(data: object) {
    this.currentCommonInputSelectionsMessageSource.next(data);
  }

  setActiveSavedFilters(data: object) {
    this.activeSavedFiltersMessageSource.next(data);
  }

  setActiveQueryName(data: string) {
    this.activeQueryNameMessageSource.next(data);
  }

  setActiveQueryId(data: number) {
    this.activeQueryIdMessageSource.next(data);
  }

  setRawResultsData(data: object) {
    this.rawResultsMessageSource.next(data);
  }

  setLastExecutedQueryInfo(data: object) {
    this.lastExecutedQueryInfoMessageSource.next(data);
  }

  setAllIndications(data: object) {
    this.allIndicationsMessageSource.next(data);
  }

  setIndicationSelections(data: object) {
    this.indicationSelectionsMessageSource.next(data);
  }

  setSeletedDataSets(data: object) {
    this.selectedDataSetsMessageSource.next(data);
  }

  setSelectedSearchIndication(data: object) {
    this.selectedSearchIndicationMessageSource.next(data);
  }

  setValidationErrors(data: object) {
    this.setValidationErrorsMessageSource.next(data);
  }

  setForceRunValidationCheck() {
    this.forceRunValidationCheckMessageSource.next(true);
  }

  setSummarySectionInfo(data: object) {
    this.summarySectionInfoMessageSource.next(data);
  }
}
